// 验证空值
// 0: 合法数据
// 1: 为空
export function validateEmpty(val) {
  val = val ? val.replace(/\s/gi, '') : '';
  if (!val || val === '请选择') {
    return 1;
  }
  return 0;
}

// 验证是否在大小区间之间
// 0：合法
// 1：不能大于最大值
// 2：不能小于最小值
export function validateMinMax(val, min, max) {
  const myVal = isNaN(parseFloat(val)) ? 0 : parseFloat(val);
  const myMin = isNaN(parseFloat(min)) ? 0 : parseFloat(min);
  const myMax = isNaN(parseFloat(max)) ? 0 : parseFloat(max);
  if (myVal > myMax) {
    return 1;
  }
  if (myVal < myMin) {
    return 2;
  }
  return 0;
}

// 验证费率
// 0: 合法数据
// 1: 为空
// 2: 小数点太多
// 3: 不是两位小数
export function validateRate(val) {
  if (!val) {
    return 1;
  }
  const arr = String(val).split('.');
  if (arr.length > 2) {
    return 2;
  }
  if (arr[1] && arr[1].length > 2) {
    return 3;
  }
  return 0;
}

// 验证金额
// 0: 合法数据
// 1: 为空
// 2: 小数点太多
// 3: 不是两位小数
export function validateMoney(val) {
  if (!val) {
    return 1;
  }
  const arr = String(val).split('.');
  if (arr.length > 2) {
    return 2;
  }
  if (arr[1] && arr[1].length > 2) {
    return 3;
  }
  return 0;
}

// 验证金额(不能有小数)
// 0: 合法数据
// 1: 为空
// 2: 有小数
// 3: 小数点太多
export function validateZhenMoney(val) {
  if (val === '') {
    return 1;
  }
  const arr = String(val).split('.');
  if (arr[1] && arr[1].length > 0) {
    return 2;
  }
  if (arr.length > 2) {
    return 3;
  }
  return 0;
}

// 验证手机号码
// 0: 合法数据
// 1: 为空
// 2: 格式不正确
export function validateMobile(val) {
  val = val.replace(/\s/gi, '');
  if (!val) {
    return 1;
  }
  const regExp = PUBLIC_MOBILE_REGEXP; /*global PUBLIC_MOBILE_REGEXP*/
  if (!regExp.test(val)) {
    return 2;
  }
  return 0;
}

// 验证密码
// 0: 合法数据
// 1: 为空
// 2: 不是6位以上数字或字母
// 3: 重复数字
// 4: 连续数字
export function validatePassword(val) {
  if (val === '') {
    return 1;
  }
  const arr = val.split('');
  const isOk = /^[A-Za-z0-9]+$/.test(val);
  if (arr.length < 6 || !isOk) {
    return 2;
  }
  // 验证都是数字的情况下不能是相同\连续的数字
  if (/^[0-9]*[1-9][0-9]*$/.test(val)) {
    const differ = [];
    const pwdArr = val.split('');
    let count0 = 0;
    let count1 = 0;
    let count2 = 0;
    for (let i = 0; i < pwdArr.length - 1; ++i) {
      differ.push(pwdArr[i + 1] - pwdArr[i]);
    }
    for (let i = 0; i < differ.length; i++) {
      differ[i] === 0 && count0++;
      differ[i] === 1 && count1++;
      differ[i] === -1 && count2++;
    }
    if (count0 === differ.length) {
      return 3;
    }
    if (count1 === differ.length) {
      return 4;
    }
    if (count2 === differ.length) {
      return 4;
    }
  }
  return 0;
}

// 验证身份证
// 0: 合法数据
// 1: 为空
// 2: 格式不正确
export function validateIdCard(value) {
  if (!value) {
    return 1;
  }
  value = value.replace(/\s/gi, '').toUpperCase();
  // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
  if (!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(value)) {
    return 2;
  }
  // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
  // 下面分别分析出生日期和校验位
  let re;
  const len = value.length;
  if (len === 15) {
    re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
    const arrSplit = value.match(re);
    // 检查生日日期是否正确
    const dtmBirth = new Date(
      '19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]
    );
    const bGoodDay =
      dtmBirth.getFullYear() === Number(arrSplit[2]) &&
      dtmBirth.getMonth() + 1 === Number(arrSplit[3]) &&
      dtmBirth.getDate() === Number(arrSplit[4]);
    if (!bGoodDay) {
      return 2;
    } else {
      // 将15位身份证转成18位
      // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
      const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      const arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
      let nTemp = 0;

      let i;
      value = value.substr(0, 6) + '19' + value.substr(6, value.length - 6);
      for (i = 0; i < 17; i++) {
        nTemp += value.substr(i, 1) * arrInt[i];
      }
      value += arrCh[nTemp % 11];
      return 0;
    }
  }
  if (len === 18) {
    re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
    const arrSplit = value.match(re);

    // 检查生日日期是否正确
    const dtmBirth = new Date(
      arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]
    );
    const bGoodDay =
      dtmBirth.getFullYear() === Number(arrSplit[2]) &&
      dtmBirth.getMonth() + 1 === Number(arrSplit[3]) &&
      dtmBirth.getDate() === Number(arrSplit[4]);
    if (!bGoodDay) {
      return 2;
    } else {
      // 检验18位身份证的校验码是否正确。
      // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
      let valnum = null;
      const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      const arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
      let nTemp = 0;
      let i;
      for (i = 0; i < 17; i++) {
        nTemp += value.substr(i, 1) * arrInt[i];
      }
      valnum = arrCh[nTemp % 11];
      if (valnum !== value.substr(17, 1)) {
        return 2;
      }
      return 0;
    }
  }
  return 2;
}

// 验证一般银行卡号 16-19位
// 0: 合法数据
// 1: 为空
// 2: 银行卡号长度必须在16到19之间
// 3: 银行卡号开头6位不符合规范
export function validateBankCard(val) {
  val = val.replace(/\s/gi, '');
  if (!val) {
    return 1;
  }
  if (val.length < 16 || val.length > 19) {
    return 2;
  }
  // 开头6位
  const str_bin = '10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99';
  if (str_bin.indexOf(val.substring(0, 2)) === -1) {
    return 3;
  }
  return 0;
}

// 验证对公银行卡号
// 0: 合法数据
// 1: 为空
export function validateBankCardPublic(val) {
  val = val.replace(/\s/gi, '');
  if (!val) {
    return 1;
  }
  return 0;
}

// 验证营业执照号：复杂验证
// 0: 合法数据
// 1: 为空
// 2: 非法数据
export function validateLicenseNo(val) {
  val = val.replace(/\s/gi, '');
  if (!val) {
    return 1;
  }
  const patrn = /^[0-9A-Z]+$/;
  // 18位校验及大写校验
  if ((val.length !== 18) || (patrn.test(val) === false)) {
    return 2;
  } else {
    let Ancode;// 统一社会信用代码的每一个值
    let Ancodevalue;// 统一社会信用代码每一个值的权重
    let total = 0;
    const weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];// 加权因子
    const str = '0123456789ABCDEFGHJKLMNPQRTUWXY';
    // 不用I、O、S、V、Z
    for (var i = 0; i < val.length - 1; i++) {
      Ancode = val.substring(i, i + 1);
      Ancodevalue = str.indexOf(Ancode);
      total = total + Ancodevalue * weightedfactors[i];
      // 权重与加权因子相乘之和
    }
    let logiccheckcode = 31 - total % 31;
    if (logiccheckcode === 31) {
      logiccheckcode = 0;
    }
    const Str = '0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y';
    const Array_Str = Str.split(',');
    logiccheckcode = Array_Str[logiccheckcode];

    const checkcode = val.substring(17, 18);
    if (logiccheckcode !== checkcode) {
      return 2;
    }
  }
  return 0;
}

// 验证营业执照号：简单验证
// 0: 合法数据
// 1: 为空
// 2: 非法数据
export function validateLicenseNo2(val) {
  val = val.replace(/\s/gi, '');
  if (!val) {
    return 1;
  }
  if (val.length < 10 || val.length > 20) {
    return 2;
  }
}

// 验证小微商户店铺名
// 0: 合法数据
// 1: 为空
// 2: 小于最小值
export function validateXwCompanyName(val, min) {
  val = val ? val.replace(/\s/gi, '') : '';
  if (!val || val === '请选择') {
    return 1;
  }
  if (val.length < min) {
    return 2;
  }
  return 0;
}
